import { create } from 'zustand';

export type ThemeOption = 'light' | 'dark' | 'system';

export interface UIStore {
  diffViewMode: 'unified' | 'split';
  theme: ThemeOption;
  sidebarCollapsed: boolean;
  setDiffViewMode: (mode: 'unified' | 'split') => void;
  setTheme: (theme: ThemeOption) => void;
  toggleSidebar: () => void;
}

function getStoredTheme(): ThemeOption {
  try {
    const stored = localStorage.getItem('theme');
    if (stored === 'light' || stored === 'dark' || stored === 'system') {
      return stored;
    }
  } catch {
    // localStorage may be unavailable (e.g., private browsing in some browsers)
  }
  return 'system';
}

function persistTheme(theme: ThemeOption): void {
  try {
    localStorage.setItem('theme', theme);
  } catch {
    // Silently fail if localStorage is unavailable
  }
}

export const useUIStore = create<UIStore>((set) => ({
  diffViewMode: 'unified',
  theme: getStoredTheme(),
  sidebarCollapsed: false,

  setDiffViewMode: (mode: 'unified' | 'split') =>
    set({ diffViewMode: mode }),

  setTheme: (theme: ThemeOption) => {
    persistTheme(theme);
    set({ theme });
  },

  toggleSidebar: () =>
    set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
}));
